import { Alert, AlertTitle } from '@mui/material'

import { UseIssueTranslationOptions, useIssueTranslation } from './use-issue-translation'
import { Links } from './Links'
import { useTranslation } from 'react-i18next'

interface IssueProps extends UseIssueTranslationOptions {
  isOtherShop: boolean
}

export function Issue(props: IssueProps) {
  const { t } = useTranslation()
  const translation = useIssueTranslation({
    deletedItemString: props.deletedItemString,
    kind: props.kind,
    scope: props.scope,
    uuids: props.uuids,
    value: props.value
  })

  const severity = props.kind === 'rejection' ? 'error' : 'warning'

  return (
    <Alert severity={severity}>
      <AlertTitle>{translation.title}</AlertTitle>
      {translation.description}
      {props.isOtherShop ? (
        <div>{t('DeleteFlow.IsOtherShop')}</div>
      ) : (
        <Links multiple={translation.multiple} text={translation.link} urls={translation.urls} />
      )}
    </Alert>
  )
}
